(() => {
  const currentScript = document.currentScript;
  const currentSrc = currentScript?.src;

  if (currentSrc) {
    try {
      const originalUrl = new URL(currentSrc, window.location.href);
      originalUrl.pathname = originalUrl.pathname.replace(
        /saratti-gemstone-mobile-menu\.js$/,
        'saratti-gemstone-mobile-menu.pre-piaget-header-v2-20260719.js'
      );
      originalUrl.search = new URL(currentSrc, window.location.href).search;

      if (originalUrl.pathname !== new URL(currentSrc, window.location.href).pathname) {
        const originalScript = document.createElement('script');
        originalScript.src = originalUrl.toString();
        originalScript.async = false;
        originalScript.dataset.sarattiOriginalGemstoneMenu = 'true';
        document.head.appendChild(originalScript);
      }
    } catch (error) {
      console.warn('SARATTI: original gemstone menu script could not be loaded.', error);
    }
  }

  const STYLE_ID = 'saratti-piaget-header-v2';
  const DESKTOP_QUERY = '(min-width: 1280px)';
  const WISHLIST_PATH = '/a/page/wishlist';

  const styles = `
.cc-header .saratti-header-currency-slot,
.cc-header .saratti-header-wishlist {
  display: none;
}

@media (min-width: 1280px) {
  .cc-header .header {
    padding: 0 !important;
  }

  .cc-header .header__grid {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) !important;
    grid-template-areas: "menu logo tools" !important;
    align-items: center !important;
    column-gap: clamp(34px, 3vw, 62px) !important;
    min-height: 108px !important;
    width: 100% !important;
    max-width: none !important;
    padding: 0 clamp(48px, 4.2vw, 72px) !important;
    position: relative !important;
    flex-wrap: nowrap !important;
  }

  .cc-header .header__logo {
    grid-area: logo !important;
    order: 0 !important;
    justify-self: center !important;
    align-self: center !important;
    flex: none !important;
    width: auto !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
    z-index: 4 !important;
  }

  .cc-header .header__logo .logo__link > span {
    width: clamp(150px, 10vw, 178px) !important;
    max-width: clamp(150px, 10vw, 178px) !important;
  }

  .cc-header .header__logo img {
    display: block !important;
    width: 100% !important;
    height: auto !important;
  }

  .cc-header .header__search {
    position: absolute !important;
    top: calc(100% + 1px) !important;
    right: clamp(48px, 4.2vw, 72px) !important;
    left: auto !important;
    z-index: 100 !important;
    order: 0 !important;
    width: min(520px, 42vw) !important;
    max-width: 520px !important;
    margin: 0 !important;
    padding: 12px 0 14px !important;
    background: #ffffff !important;
    flex: none !important;
  }

  .cc-header .header__icons {
    grid-area: tools !important;
    order: 0 !important;
    justify-self: end !important;
    align-self: center !important;
    display: flex !important;
    align-items: center !important;
    gap: 15px !important;
    flex: none !important;
    margin: 0 !important;
    padding: 0 !important;
    z-index: 4 !important;
  }

  .cc-header .header__icon,
  .cc-header .saratti-header-wishlist {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
    padding: 0 !important;
    border: 0 !important;
    background: transparent !important;
    color: rgb(var(--text-color)) !important;
  }

  .cc-header .header__icon svg,
  .cc-header .saratti-header-wishlist svg {
    width: 20px !important;
    height: 20px !important;
    stroke-width: 1.6 !important;
  }

  .cc-header .main-menu {
    grid-area: menu !important;
    order: 0 !important;
    justify-self: start !important;
    align-self: stretch !important;
    width: auto !important;
    min-width: 0 !important;
    margin: 0 !important;
    background: transparent !important;
    position: static !important;
  }

  .cc-header .main-menu__disclosure,
  .cc-header .main-menu__content,
  .cc-header .main-menu__content > nav,
  .cc-header .main-nav,
  .cc-header .main-nav > li,
  .cc-header .main-nav > li > details,
  .cc-header .main-nav > li > details > summary {
    height: 100% !important;
  }

  .cc-header .main-menu__disclosure,
  .cc-header .main-menu__content {
    position: static !important;
  }

  .cc-header .main-menu__content {
    display: flex !important;
    align-items: stretch !important;
    justify-content: flex-start !important;
    width: auto !important;
    min-width: 0 !important;
  }

  .cc-header .main-menu__content > nav,
  .cc-header .main-nav,
  .cc-header .main-nav > li,
  .cc-header .main-nav > li > details,
  .cc-header .main-nav > li > details > summary {
    display: flex !important;
    align-items: stretch !important;
  }

  .cc-header .main-nav {
    flex-wrap: nowrap !important;
    justify-content: flex-start !important;
    gap: clamp(18px, 1.35vw, 28px) !important;
    margin: 0 !important;
  }

  .cc-header .main-nav__item--primary {
    display: flex !important;
    align-items: center !important;
    min-height: 108px !important;
    margin: 0 !important;
    padding: 2px 0 0 !important;
    font-size: clamp(12.5px, 0.86vw, 14px) !important;
    font-weight: 600 !important;
    line-height: 1.2 !important;
    letter-spacing: 0.085em !important;
    white-space: nowrap !important;
  }

  .cc-header .main-nav__item--primary svg {
    width: 11px !important;
    height: 11px !important;
    margin-inline-start: 7px !important;
  }

  .cc-header .saratti-header-currency-slot {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    min-width: 56px !important;
    height: 28px !important;
  }

  .cc-header .saratti-header-currency-slot .buckscc-currency-box,
  .cc-header .saratti-header-currency-slot .buckscc-currency-wrapper {
    position: static !important;
    inset: auto !important;
    transform: none !important;
    display: inline-flex !important;
    align-items: center !important;
    width: auto !important;
    min-width: 0 !important;
    height: 28px !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .cc-header .saratti-header-currency-slot .buckscc-select,
  .cc-header .saratti-header-currency-slot .buckscc-select-styled,
  .cc-header .saratti-header-currency-slot .hxoSelectTheme,
  .cc-header .saratti-header-currency-slot select,
  .cc-header .saratti-header-currency-slot button {
    min-width: 0 !important;
    height: 28px !important;
    margin: 0 !important;
    padding: 0 3px !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
    color: rgb(var(--text-color)) !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    line-height: 28px !important;
    letter-spacing: 0.06em !important;
  }

  .cc-header .saratti-header-currency-slot img {
    width: 16px !important;
    height: auto !important;
    margin-inline-end: 5px !important;
  }

  .cc-header .header__grid--left-logo .header__logo,
  .cc-header .header__grid--left-logo .main-menu,
  .cc-header .header__grid--left-logo .header__icons {
    flex: none !important;
  }
}
`;

  const installStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = styles;
    document.head.appendChild(style);
  };

  const heartSvg = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

  const desktopMedia = window.matchMedia(DESKTOP_QUERY);
  let currencyElement = null;
  let currencyMarker = null;
  let observer = null;
  let retryTimer = null;

  const findCurrency = () => {
    const selectors = [
      '.buckscc-currency-box',
      '#buckscc-currency-box',
      '.buckscc-currency-wrapper'
    ];

    for (const selector of selectors) {
      const found = Array.from(document.querySelectorAll(selector)).find(
        (element) => !element.closest('.saratti-header-currency-slot')
      );
      if (found) return found;
    }
    return null;
  };

  const restoreCurrency = () => {
    if (!currencyElement || !currencyMarker?.parentNode) return;
    currencyMarker.parentNode.insertBefore(currencyElement, currencyMarker.nextSibling);
  };

  const syncUtilities = () => {
    const tools = document.querySelector('.cc-header .header__icons');
    if (!tools) return false;

    if (!desktopMedia.matches) {
      restoreCurrency();
      tools.querySelector('.saratti-header-currency-slot')?.remove();
      tools.querySelector('.saratti-header-wishlist[data-saratti-created="true"]')?.remove();
      return false;
    }

    let currencySlot = tools.querySelector('.saratti-header-currency-slot');
    if (!currencySlot) {
      currencySlot = document.createElement('span');
      currencySlot.className = 'saratti-header-currency-slot';
      currencySlot.setAttribute('aria-label', 'Currency selector');
      tools.prepend(currencySlot);
    }

    if (!currencyElement || !document.documentElement.contains(currencyElement)) {
      currencyElement = findCurrency();
    }

    if (currencyElement && !currencySlot.contains(currencyElement)) {
      if (!currencyMarker || !currencyMarker.parentNode) {
        currencyMarker = document.createComment('SARATTI BUCKS currency origin');
        currencyElement.parentNode?.insertBefore(currencyMarker, currencyElement);
      }
      currencySlot.appendChild(currencyElement);
    }

    let wishlist = Array.from(tools.querySelectorAll('a')).find((anchor) => {
      try {
        return new URL(anchor.href, window.location.origin).pathname === WISHLIST_PATH;
      } catch (_) {
        return false;
      }
    });

    if (!wishlist) {
      wishlist = document.createElement('a');
      wishlist.href = WISHLIST_PATH;
      wishlist.dataset.sarattiCreated = 'true';
      wishlist.innerHTML = `${heartSvg}<span class="visually-hidden">Wishlist</span>`;
      const cart = tools.querySelector('#cart-icon');
      tools.insertBefore(wishlist, cart || null);
    }

    wishlist.classList.add('header__icon', 'saratti-header-wishlist', 'text-current');
    wishlist.setAttribute('aria-label', 'Wishlist');

    return Boolean(currencyElement);
  };

  const boot = () => {
    installStyles();
    syncUtilities();

    observer = new MutationObserver(() => {
      if (syncUtilities()) observer?.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    let attempts = 0;
    retryTimer = window.setInterval(() => {
      syncUtilities();
      attempts += 1;
      if (attempts >= 40 || currencyElement) {
        window.clearInterval(retryTimer);
        observer?.disconnect();
      }
    }, 300);

    const handleViewportChange = () => {
      syncUtilities();
      if (desktopMedia.matches && !currencyElement) {
        observer?.observe(document.documentElement, { childList: true, subtree: true });
      }
    };

    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', handleViewportChange);
    } else {
      desktopMedia.addListener(handleViewportChange);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
